document.addEventListener('DOMContentLoaded', () => {
  const dropDown = document.querySelectorAll('.dropdown-item');

  dropDown.forEach(selector => {
    selector.addEventListener('click', event => {
      dropDown.forEach(selector => {
        if (selector != event.currentTarget) {
          selector.classList.remove("active");
        }
      })

      event.currentTarget.classList.toggle("active");
    });
  });
});
